import React, { ComponentState, useEffect, useState } from "react";
import Loader from "../../../control-components/loader/loader";
import { useSelector, useDispatch } from "react-redux";
import { Dialog } from "@progress/kendo-react-dialogs";
import NotificationManager from "react-notifications/lib/NotificationManager";
import ErrorHelper from "../../../helper/error-helper";
import MultiSelectDropDown from "../../../control-components/multi-select-drop-down/multi-select-drop-down";
import { StaffService } from "../../../services/staffService";
import { renderErrors } from "src/helper/error-message-helper";
import { assignClinicTags, getClinicStoredDocumentByClinicId, getClinicTags } from "src/redux/actions";


const AddClinicDocumentTags = ({ onClose, docId, staffTags }) => {
    const state: ComponentState = useSelector(states => {
        return states;
    });
    const { listClinicTags } = state['ClinicsReducer']
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState<any>("");
    const [settingError, setSettingError] = useState(false);
    const [tagsData, setTagsData] = useState([]);
    const clinicId = useSelector((state: any) => state.loggedIn.clinicId);
    const [isAccepted, setIsAccepted] = useState<boolean>(false)
    let [fields, setFields] = useState({
        tagName: "",
    });

    useEffect(() => {
        if (!isAccepted) {
            dispatch(getClinicTags(clinicId))
            setIsAccepted(true)
        }
    }, [])

    useEffect(() => {
        if (listClinicTags != null && listClinicTags.length > 0) {
            let newArray = listClinicTags.filter((element: any) => !staffTags.includes(element.color))
            setTagsData(newArray);
        }
    }, [listClinicTags])

    const assignTags = async () => {
        setLoading(true);
        await StaffService.assignTagToClinicDocument(fields, docId)
            .then((result) => {
                setLoading(false);
                NotificationManager.success("Tags assigned successfully");
                onClose({ updated: true });
                dispatch(getClinicStoredDocumentByClinicId())

            })
            .catch((error) => {
                setLoading(false);
                renderErrors(error.message);
            });
    };

    const handleSubmit = () => {
        setSettingError(true);
        if (handleValidation()) {
            assignTags();
        }
    };

    const handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;

        setFields({
            ...fields,
            [name]: value,
        });
    };

    const handleValidation = () => {
        let errors: any = {};
        let formIsValid = true;
        if (!fields.tagName) {
            formIsValid = false;
            errors["tagName"] = ErrorHelper.TAG_NAME;
        }
        setErrors(errors);
        return formIsValid;
    };

    const itemRender = (li, itemProps) => {
        const itemObj = itemProps.dataItem;
        const itemChildren = (
            <>
                <span
                    className="k-scheduler-mark"
                    style={{
                        backgroundColor: itemObj.color,
                        marginRight: 4,
                    }}
                />
                <span>{itemObj.tagName}</span>
            </>
        );
        return React.cloneElement(li, li.props, itemChildren);
    };

    return (
        <div>
            <Dialog onClose={onClose} title={"Assign Tags"} className="small-dailog width_90 SmallHEight blue_theme" width={"40%"} height={"40%"}>
                <div className="edit-client-popup">
                    <div className="popup-modal slibling-data">
                        <div className="">
                            <div>
                                <MultiSelectDropDown
                                    label="Tag Name"
                                    onChange={handleChange}
                                    data={tagsData}
                                    value={fields.tagName}
                                    textField="tagName"
                                    name="tagName"
                                    dataItemKey="id"
                                    validityStyles={settingError}
                                    required={true}
                                    error={fields.tagName.length === 0 && errors.tagName}
                                    itemRender={itemRender}
                                    placeholder={"Tag Name"}
                                />
                            </div>
                        </div>
                    </div>

                    {loading === true && <Loader />}
                </div>
                <div className="preview-btn-bottom">
                    <div className="border-bottom-line"></div>
                    <div className="d-flex my-3 mx-2">
                        <div className="right-sde">
                            <button
                                className="submitButon"
                                onClick={handleSubmit}
                            >
                                Assign
                            </button>
                        </div>
                        <div className="right-sde-grey">
                            <button
                                className="cancelBtn"
                                onClick={onClose}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </Dialog>
        </div>
    );
};
export default AddClinicDocumentTags;
